export default __webpack_public_path__ + "static/media/Maahes' Crackling Spite.f65307b8.jpg";